import { render, staticRenderFns } from "./BasicEditerV3.vue?vue&type=template&id=3b2ee080&scoped=true"
import script from "./BasicEditerV3.vue?vue&type=script&lang=js"
export * from "./BasicEditerV3.vue?vue&type=script&lang=js"
import style0 from "./BasicEditerV3.vue?vue&type=style&index=0&id=3b2ee080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ee080",
  null
  
)

export default component.exports